import { gql } from "@apollo/client";

export const getSingleClaim = gql`
  query GetSingleClaim($claimId: ID!) {
    getSingleClaim(claim_id: $claimId) {
      offer_claim_id
      offer_id
      claim_amount
      claim_date
      claim_comment
      currency
      rate
      created_at
      offer {
        offer_id
        offer_detail {
          insured_by
          policy_number
        }
      }
    }
  }
`;

export const getClaims = gql`
  query GetClaims(
    $offerId: ID
    $limit: Int
    $offset: Int
    $dateFrom: String
    $dateTo: String
    $currency: String
  ) {
    getClaims(
      offer_id: $offerId
      limit: $limit
      offset: $offset
      date_from: $dateFrom
      date_to: $dateTo
      currency: $currency
    ) {
      offer_claim_id
      offer_id
      claim_amount
      claim_date
      claim_comment
      claim_share_percentage
      currency
      rate
      created_at
      offer {
        offer_id
        offer_detail {
          insured_by
          policy_number
        }
      }
    }
  }
`;

export const getClaimThread = gql`
  query GetClaimThread($claimId: ID, $reinsurerId: ID) {
    getClaimThread(claim_id: $claimId, reinsurer_id: $reinsurerId) {
      status
      message
      data {
        claim_id
        thread_id
        subject
        messages {
          id
          sender_name
          body
          is_read
          created_at
        }
      }
    }
  }
`;


export const viewClaimAttachment = gql`
  query ViewClaimAttachment($attachmentId: ID!, $includeContent: Boolean) {
    viewClaimAttachment(attachment_id: $attachmentId, include_content: $includeContent) {
      file_url
      download_url
      content_type
      file_name
      content
      file_size
    }
  }
`;

export const listClaimAttachments = gql`
  query ListClaimAttachments($claimId: ID!) {
    listClaimAttachments(claim_id: $claimId) {
      status
      message
      data {
        claim_id
        attachments {
          id
          file_name
          file_path
          mime_type
          file_size
          file_url
          uploaded_at
        }
      }
    }
  }
`;
